import type {Rec} from 'src/typings';
import type {RecordClipboardService} from '../record-clipboard.service';
import {join} from 'shared/utils/array-utils';
import type {Observable} from 'rxjs';

export class KpRecordClipboardPanelPresenter {
    public static presenterName = 'kpRecordClipboardPanelPresenter';

    private CLIPBOARD_PANEL_ITEMS_LIMIT = 8;

    /*@ngInject*/
    constructor(private recordClipboardService: RecordClipboardService) {
    }

    public getLimit(): number {
        return this.CLIPBOARD_PANEL_ITEMS_LIMIT;
    }

    public getRecords$(): Observable<Rec[]> {
        return this.recordClipboardService.getRecords$();
    }

    public removeAll() {
        return this.recordClipboardService.removeAll();
    }

    public getExportLinks(records: Rec[]): Record<'ris' | 'xls' | 'csv' | 'doc', string> {
        const recordsIds = records.map((record) => record.id);

        const ris = this.getExportLink(recordsIds, 'records-ris:');
        const xls = this.getExportLink(recordsIds, 'records-xls:');
        const csv = this.getExportLink(recordsIds, 'records-csv:');
        const doc = this.getExportLink(recordsIds, 'records-doc:/html/documents-doc.vtl');

        return {ris, xls, csv, doc};
    }

    private getExportLink(ids: string[], targetType: string): string {
        return `/export?target=${targetType}&object=${join(ids, ',')}`;
    }
}